
    var riot = require('riot')
    
riot.tag2('tags-input', '<div class="current-tags"> <h4>Current Tags</h4> <p if="{currentTags.length == 0}">None found</p> <div class="tags btn-toolbar"> <div each="{tag in currentTags}" onclick="{parent.removeTag.bind(null,tag)}" class="btn btn-primary btn-xs">{tag.label} <i class="fa fa-times remove"></i></div> </div> </div> <div class="form"> <div class="form-group"> <h4>Add Tag</h4> <div class="input-group"> <input name="add_label_input" class="form-control"> <div class="input-group-btn"> <button type="submit" onclick="{addTag}" class="btn btn-primary">Add</button> </div> </div> </div> </div> <div class="all-tags"> <h4>All Tags</h4> <p if="{allTags.length == 0}">None found</p> <div class="tags btn-toolbar"> <div each="{tag in allTags}" onclick="{parent.useTag.bind(null, tag)}" class="btn btn-primary btn-xs">{tag.label} <i class="fa fa-plus add"></i></div> </div> </div>', '', '', function(opts) {
var api, resource;

resource = require('riot-kit/utils/apiResource.coffee');

api = new resource('/duocms/api/tags', true);

this.on('mount', function() {
  this.getAllTags();
  return this.getCurrentTags();
});

this.getAllTags = (function(_this) {
  return function() {
    return api.get(function(data) {
      _this.allTags = data;
      return _this.update();
    });
  };
})(this);

this.getCurrentTags = (function(_this) {
  return function() {
    return api.get({
      id: opts.page_id
    }, function(data) {
      _this.currentTags = data;
      return _this.update();
    });
  };
})(this);

this.useTag = (function(_this) {
  return function(tag) {
    var already, newTag;
    already = (_this.currentTags.filter(function(t) {
      return t.label === tag.label;
    })).length;
    if (already > 0) {
      return;
    }
    newTag = {
      page_id: opts.page_id,
      label: tag.label
    };
    return api.save(newTag, function(data) {
      _this.currentTags.push(data);
      return _this.update();
    });
  };
})(this);

this.addTag = (function(_this) {
  return function() {
    var newTag;
    newTag = {
      page_id: opts.page_id,
      label: _this.add_label_input.value
    };
    return api.save(newTag, function(data) {
      _this.add_label_input.value = '';
      _this.currentTags.push(data);
      _this.getAllTags();
      return _this.update();
    });
  };
})(this);

this.removeTag = (function(_this) {
  return function(tag) {
    return api.remove({
      id: tag.id
    }, function() {
      _this.currentTags = _this.currentTags.filter(function(t) {
        return tag.id !== t.id;
      });
      _this.getAllTags();
      return _this.update();
    });
  };
})(this);
});
    
  